import RouteContainer from 'containers/RouteContainer';
import Component from './containers/LifestyleContainer';

export const path = `${DOCUMENTS_PATH}/lifestyle`;
export const navigation = { name: 'lifestyle', id: 'lifestyle.title' };
export const navMsLifestyle = { name: 'msLifestyle', id: 'lifestyle.title', nonNavigable: true };

export default RouteContainer(path, Component);
